export const environment = {
  production: true,
  environment_name: 'rosebank',
  environment_title: 'Rosebank Mall',
  environment_url: 'https://www.rosebankmall.co.za/',
  environment: 'prod',
  api_base_url: 'https://api.hyprop.co.za/',
  api_auth_url: 'https://auth-api.hyprop.co.za/',
  cdn_url: 'https://cdn.hyprop.co.za/',
  mall_id: 'd29b471f-375e-4bd3-ab6c-85fea74ad38e',
  addressLat: -26.146272316458468,
  addressLng: 28.041202712723287,
  recaptcha_key: '6LeJuCcbAAAAAMiZ_rBgq7NTiEQVrjNZ1J6f1zAL',
  social_google_key:
    '150343683952-08m97b42cr2fc2v4j1qnckfmq1np0hn9.apps.googleusercontent.com',
  social_facebook_key: '253233436432992',
  sso_url: 'https://sso.hyprop.co.za',
  google_verification: 'hXYuqMd-gF_VUY_OHGVz-Oumk-rMHhYR38OnrgmoPxU',
  street_address: '15A Cradock Ave, Rosebank',
  address_locality: 'Johannesburg',
  postal_code: '2196',
  address_country: 'ZA',
  contact_form_uuid: 'sk6ipkrc',
  google_api_key: 'AIzaSyCEvUD2-2IuJdnY4mCmiPHjrdjDsskcTG8',
  form4_link:
    'https://cdn.hyprop.co.za/document/2024/2/19/b2213e98-9cbe-4799-9eb2-b336daeca01f/11e16c5e-b384-447e-b767-91e6055fccf1.pdf',
  tiktok_url: 'https://www.tiktok.com/@rosebankmall',
};
